import { VSlider } from 'vuetify/lib/components/VSlider';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VSlider,{staticClass:"slider",attrs:{"disabled":_vm.disabled,"tick-size":"18","track-color":"elements","track-fill-color":"elements","min":_vm.min,"max":_vm.max,"step":_vm.step,"value":_vm.value},on:{"end":_setup.onEnd,"input":_setup.updateValue,"start":_setup.onStart}})
}
var staticRenderFns = []

export { render, staticRenderFns }